var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#E6F6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 23.125C18.8983 23.125 21.1719 20.8514 21.1719 18.0469C21.1719 15.2423 18.8983 12.9688 16.0938 12.9688C13.2892 12.9688 11.0156 15.2423 11.0156 18.0469C11.0156 20.8514 13.2892 23.125 16.0938 23.125Z",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6763 13.1543C23.1252 13.0325 23.5881 12.9702 24.0532 12.9688C25.4 12.9688 26.6917 13.5038 27.644 14.4561C28.5963 15.4084 29.1313 16.7001 29.1313 18.0469C29.1313 19.3937 28.5963 20.6853 27.644 21.6377C26.6917 22.59 25.4 23.125 24.0532 23.125",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 26.7777C9.85542 25.6493 10.9082 24.7284 12.132 24.0927C13.3558 23.4569 14.7147 23.125 16.0938 23.125C17.4728 23.125 18.8317 23.4569 20.0555 24.0927C21.2793 24.7284 22.3321 25.6493 23.125 26.7777",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0527 23.125C25.4319 23.1241 26.791 23.4556 28.015 24.0914C29.2389 24.7272 30.2916 25.6485 31.084 26.7773",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupIcon);
export default __webpack_public_path__ + "static/media/userGroupIcon.08bc01a171f980a5fd105a397e89a610.svg";
export { ForwardRef as ReactComponent };